export const getCssSafeUrl = (url: string) => {
    // Encode the whole URL safely and escape parentheses
    return `url("${encodeURI(url).replace(/\(/g, "%28").replace(/\)/g, "%29")}")`;
};
